module.exports = __webpack_public_path__ + "img/game_main_pc_226_off.3a8c336f.png";